// src/components/HowItWorksStep.js

import React from 'react';
import { motion } from 'framer-motion'; // <-- Framer Motion Import

// =======================================
// FRAMER MOTION VARIANTS (Child Item - Spring Bounce)
// =======================================
const item = {
  hidden: { y: 50, opacity: 0 }, // Starts 50px down
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      // Spring Transition for the bounce effect
      type: "spring", 
      stiffness: 100, 
      damping: 10,   
      delay: 0.1,    
    }
  }
};

const HowItWorksStep = ({ icon: Icon, stepNumber, title, description }) => {
  return (
    <motion.div 
      className="how-it-works-step glossy-card"
      
      // Staggered Entrance Animation (receives timing from parent)
      variants={item} 
      
      // Hover Effect Definition
      whileHover={{ 
        scale: 1.05, 
        boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)" 
      }}
      
      // Transition for the Hover Effect (Uses a separate spring)
      transition={{ 
        type: "spring", 
        stiffness: 400, 
        damping: 10 
      }}
    >
      {/* Step Number Badge */}
      <div className="step-number-badge">{stepNumber}</div>
      
      {/* Icon Placeholder (Assumes Icon is passed as a component) */}
      <div className="step-icon-wrapper">
        <Icon className="step-icon" /> 
      </div>
      
      <h3 className="step-title">{title}</h3>
      <p className="step-description">{description}</p>
    </motion.div>
  );
};

export default HowItWorksStep;